<template>
  <div>
    <div
      class="node-wrap"
      v-if="nodeList.type != 'route' && nodeList.type != 'gather'"
    >
      <div
        class="node-wrap-box"
        :class="nodeList.type == 'start' ? 'start-node' : ''"
        v-if="bool"
      >
        <div :class="verify && nodeList.error ? 'error-style' : ''">
          <div
            class="title"
            :style="
              nodeList.type == 'approver'
                ? 'background:#FE885D'
                : nodeList.type == 'audit'
                ? 'background:#FFC42C'
                : nodeList.type == 'subProcess'
                ? 'background:#D356FF'
                : nodeList.type == 'notifier'?'background:#5DC4FE'
                :nodeList.type == 'archiver'?'background:#1296DB'
                :nodeList.type == 'connector'?'background:#7D5CFF':''
            "
          >
            <div class="title-content">
              <img
                class="iconfont"
                src="../../assets/img/audit1.png"
                v-if="nodeList.type == 2"
              />
              <img
                class="iconfont"
                src="../../assets/img/subflow1.png"
                v-if="nodeList.type == 5"
              />
              <img
                class="iconfont"
                src="../../assets/img/transaction1.png"
                v-if="nodeList.type == 6"
              />
              <el-input
                v-if="nodeList.type != 'start' && isInput"
                placeholder="请输入"
                v-model="nodeList.name"
                @blur="blurEvent()"
                v-focus
              ></el-input>

              <span
                @click="clickEvent()"
                :class="nodeList.type != 'start' ? 'editable-title' : ''"
                v-else
                >{{ nodeList.name }}</span
              >
            </div>
            <i
              class="anticon el-icon-close"
              v-if="nodeList.type != 'start'"
              @click="deleteNode"
            ></i>
          </div>
          <div class="content" @click="updateNode">
            <div class="text" v-if="nodeList.recipients">
              <div v-if="nodeList.type == 'approver'">审核人： {{ nodeList.content }}</div>
              <div v-else>办理人： {{ nodeList.content }}</div>
              <!-- <div class="recipients-text">
                抄送人：{{ nodeList.recipients }}
              </div> -->
            </div>
            <div
              v-else
              :class="nodeList.type == 'start' ? 'initiator-text' : 'text'"
            >
              {{ nodeList.content || "请选择" }}
            </div>
            <i class="el-icon-arrow-right arrow"></i>
          </div>
          <div class="error_tip" v-if="verify && nodeList.error">
            <i
              class="el-icon-warning-outline"
              style="color: rgb(242, 86, 67)"
            ></i>
          </div>
        </div>
      </div>
      <add-node
        :childNodeP.sync="nodeList.childNode"
        :nodeList.sync="nodeList"
        @addNode="addNode(nodeList, nodeList.childNode)"
      ></add-node>
    </div>
    <div
      class="branch-wrap"
      v-if="nodeList.type == 'route' || nodeList.type == 'gather'"
    >
      <div class="branch-box-wrap">
        <div class="branch-box">
          <el-button
            class="add-branch"
            @click="addCondition"
            v-if="nodeList.type == 'route'"
            >添加条件</el-button
          >
          <el-button class="add-branch" @click="addCondition" v-else
            >添加分支</el-button
          >
          <div
            class="col-box"
            v-for="(item, index) in nodeList.conditionNodes"
            :key="index"
          >
            <div class="condition-node">
              <div class="condition-node-box">
                <div class="auto-judge">
                  <i
                    @click="arrTransfer(index, -1)"
                    class="el-icon-arrow-left arrows-left"
                    v-if="index != 0"
                  ></i>
                  <div
                    class="auto-judge-content"
                    :class="verify && item.error ? 'error-style' : ''"
                  >
                    <div class="title-wrapper">
                      <div class="editable-title" v-if="isInputList[index]">
                        <el-input
                          placeholder="请输入"
                          v-model="item.name"
                          @blur="blurEvent(index)"
                          v-focus
                        ></el-input>
                      </div>
                      <div
                        class="editable-title"
                        v-else
                        @click="clickEvent(index)"
                      >
                        <div>{{ item.name }}</div>
                      </div>
                      <!-- <span class="editable-title">{{ item.title }}</span> -->
                      <span class="priority-title"
                        >优先级{{ item.priorityLevel }}</span
                      >
                      <div class="icon">
                        <!-- <i
                          class="el-icon-document-copy"
                          @click="copyNode(item, index)"
                        ></i> -->
                        <img
                          src="../../assets/Slice 52@2x.png"
                          @click="copyNode(item, index)"
                          class="el-icon-document-copy"
                        />
                        <!-- <i
                          class="el-icon-close"
                          @click="delCondition(index)"
                        ></i> -->
                      </div>
                    </div>
                    <i class="el-icon-close" @click="delCondition(index)"></i>
                    <div
                      class="content"
                      @click="updateCondition(item.priorityLevel)"
                      v-if="nodeList.type == 'route'"
                    >
                      <span>{{ item.content || "请输入条件" }}</span>
                    </div>
                    <div class="content" v-if="nodeList.type == 'gather'">
                      <span>所有数据可进入该分支</span>
                    </div>
                  </div>
                  <i
                    @click="arrTransfer(index, 1)"
                    class="el-icon-arrow-right arrows"
                    v-if="index != nodeList.conditionNodes.length - 1"
                  ></i>
                  <div class="error_tip" v-if="verify && item.error">
                    <i
                      class="el-icon-warning-outline"
                      style="color: rgb(242, 86, 67)"
                    ></i>
                  </div>
                </div>
                <add-node
                  :childNodeP.sync="item.childNode"
                  :nodeList.sync="item"
                  @addNode="addNode(item, item.childNode)"
                ></add-node>
              </div>
            </div>
            <nodeWrap
              v-if="item.childNode"
              :nodeList.sync="item.childNode"
            ></nodeWrap>
            <!-- 左边的条件线隐藏 -->
            <div class="top-left-cover-line" v-if="index == 0"></div>
            <div class="bottom-left-cover-line" v-if="index == 0"></div>
            <!-- 右边的条件线隐藏 -->

            <div
              class="top-right-cover-line"
              v-if="index == nodeList.conditionNodes.length - 1"
            ></div>
            <div
              class="bottom-right-cover-line"
              v-if="index == nodeList.conditionNodes.length - 1"
            ></div>
          </div>
        </div>
        <div class="merge-branch" v-if="nodeList.type == 'gather'">
          <el-button @click="mergeCondition(nodeList.conditionNodes)"
            >分支聚合</el-button
          >
        </div>
        <add-node
          :childNodeP.sync="nodeList.childNode"
          :nodeList.sync="nodeList"
          @addNode="addNode(nodeList, nodeList.childNode)"
        ></add-node>
      </div>
    </div>
    <nodeWrap
      v-if="nodeList.childNode"
      :nodeList.sync="nodeList.childNode"
    ></nodeWrap>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import addNode from "./addNode.vue";
export default {
  components: { addNode },
  // name: "node-wrap",
  props: ["nodeList", "flowPermission"],
  data() {
    return {
      isInputList: [],
      isInput: false,
      bool: true,
      nodeList1:this.nodeList
    };
  },
  computed: {
    ...mapState([
      "auditData",
      "initiatorData",
      "makeData",
      "conditionData",
      "flowData",
      "verify",
      "notifierData",
      "filingData",
      "connectorData"
    ]),
  },
  watch: {
    initiatorData(data) {
      let that = this;
      if (data.flag && data.value.nodeId == this.nodeList1.nodeId) {
        that.bool = false;
        that.$nextTick(() => {
          that.bool = true;
          that.$emit("update:nodeList", data.value);
          console.info(data.value);
        });
      }
    },
    // 审批
    auditData(data) {
      let that = this;
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        this.bool = false;
        that.$nextTick(() => {
          that.bool = true;
          that.$emit("update:nodeList", data.value);
          
          // this.nodeList = data.value;
        });
      }
      console.info(this.nodeList);
    },
    // 办理人
    makeData(data) {
      // if (data.flag && data.id == this._uid) {
      //   this.$emit("update:nodeList", data.value);
      // }
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        console.info(this.nodeList1);
        this.bool = false;
        this.$nextTick(() => {
          this.bool = true;
          this.$emit("update:nodeList", data.value);
          // this.nodeList = data.value;
        });
      }
    },
    conditionData(data) {
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        this.$emit("update:nodeList", data.value);
      }
    },
    // 子流程
    flowData(data) {
      // if (data.flag && data.id === this._uid) {
      //   this.$emit("update:nodeList", data.value);
      // }
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        this.bool = false;
        this.$nextTick(() => {
          this.bool = true;
          this.$emit("update:nodeList", data.value);
          // this.nodeList = data.value;
        });
      }
    },
    // 抄送人
    notifierData(data){
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        this.bool = false;
        this.$nextTick(() => {
          this.bool = true;
          this.$emit("update:nodeList", data.value);
        });
      }
    },
    // 归档人
    filingData(data){
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        this.bool = false;
        this.$nextTick(() => {
          this.bool = true;
          this.$emit("update:nodeList", data.value);
        });
      }
    },
    connectorData(data){
      if (data.flag && data.value.nodeId == this.nodeList.nodeId) {
        this.bool = false;
        this.$nextTick(() => {
          this.bool = true;
          this.$emit("update:nodeList", data.value);
        });
      }
    },
  },
  methods: {
    ...mapMutations([
      "setInitiator",
      "setInitiatorData",
      "setAudit",
      "setAuditData",
      "setMake",
      "setMakeData",
      "setCondition",
      "setConditionData",
      "setMerge",
      "setFlow",
      "setFlowData",
      "setMergeData",
      "setNotifier",
      "setNotifierData",
      "setFiling",
      "setFilingData",
      "setConnector",
      "setConnectorData"
    ]),
    //   添加条件
    addCondition() {
      let i = this.nodeList.conditionNodes.length + 1;
      let str = {};
      let id = this.genUid();
      console.info(this.nodeList);
      if (this.nodeList.type == "route") {
        str = {
          type: "condition",
          name: "条件分支" + i,
          priorityLevel: i,
          conditions: [],
          childNode: null,
          prevId: this.nodeList.id,
          nodeId: id,
          content: "其他条件进入此流程",
        };
        console.info(str);
      } else {
        str = {
          type: "condition",
          name: "分支" + i,
          priorityLevel: i,
          childNode: null,
          fork: "gather",
          prevId: this.nodeList.id,
          nodeId: id,
        };
      }
      this.nodeList.conditionNodes.push(str);
      console.info(this.nodeList.conditionNodes);
      this.nodeList.conditionNodes.forEach((item) => {
        if (item.conditions.length == 0) {
          item.content = "";
          item.error = true;
        }
      });
      if (this.nodeList.conditionNodes.length > 1) {
        if (
          this.nodeList.conditionNodes[this.nodeList.conditionNodes.length - 1]
            .conditions.length == 0
        ) {
          this.nodeList.conditionNodes[
            this.nodeList.conditionNodes.length - 1
          ].content = "其他条件进入此流程";
          this.nodeList.conditionNodes[
            this.nodeList.conditionNodes.length - 1
          ].error = false;
        }
      }
      this.$emit("update:nodeList", this.nodeList);
    },
    // 随机产生uid
    genUid() {
      let genUidsoup ="0123456789";
      var length = 20;
      var soupLength = genUidsoup.length;
      var id = [];
      for (var i = 0; i < length; i++) {
        id[i] = genUidsoup.charAt(Math.random() * soupLength);
      }
      return id.join("");
    },
    addNode(data, val) {
      console.info(data);
      console.info(val);
      val.prevId = data.nodeId;
      //  this.isNode = true;
      // if (data.name == "分支2" || val.type == "subProcess") {
      //   // data.childNode = null;
      //   this.isNode = false;
      // }
      //   console.info(this.isNode);
      this.$emit("addNode", data, val);
    },
    // 点击出现弹窗
    updateNode() {
      if (this.nodeList.type == "start") {
        this.setInitiator(true);
        this.setInitiatorData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      } else if (this.nodeList.type == "approver") {
        this.setAudit(true);
        this.setAuditData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      } else if (this.nodeList.type == "subProcess") {
        this.setFlow(true);
        this.setFlowData(this.nodeList);
        this.setFlowData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      } else if (this.nodeList.type == "audit") {
        this.setMake(true);
        this.setMakeData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      }else if (this.nodeList.type == "notifier") {
        this.setNotifier(true);
        this.setNotifierData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      }else if (this.nodeList.type == "archiver") {
        this.setFiling(true);
        this.setFilingData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      }else if (this.nodeList.type == "connector") {
        this.setConnector(true);
        this.setConnectorData({
          value: JSON.parse(JSON.stringify(this.nodeList)),
          flag: false,
          id: this._uid,
        });
      }
    },
    updateCondition(val) {
      console.info(this.nodeList);
      this.setCondition(true);
      this.setConditionData({
        value: JSON.parse(JSON.stringify(this.nodeList)),
        priorityLevel: val,
        flag: false,
        id: this._uid,
      });
    },
    // 鼠标离开输入框恢复文本
    blurEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, false);
        console.info(this.nodeList.conditionNodes);
        this.nodeList.conditionNodes[index].nodeName = this.nodeList
          .conditionNodes[index].nodeName
          ? this.nodeList.conditionNodes[index].nodeName
          : "条件";
      } else {
        this.isInput = false;
        this.nodeList.nodeName = this.nodeList.nodeName
          ? this.nodeList.nodeName
          : "请输入";
      }
    },
    // 点击标题显示输入框
    clickEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, true);
      } else {
        this.isInput = true;
      }
    },
    // 优先级
    arrTransfer(index, type) {
      //向左-1,向右1
      this.nodeList.conditionNodes[index] = this.nodeList.conditionNodes.splice(
        index + type,
        1,
        this.nodeList.conditionNodes[index]
      )[0];
      this.nodeList.conditionNodes.map((item, index) => {
        item.priorityLevel = index + 1;
      });
      console.info(this.nodeList);
      if (this.nodeList.type == "route") {
        this.nodeList.conditionNodes.forEach((item) => {
          if (item.conditions.length == 0) {
            item.content = "";
            item.error = true;
          }
        });
        if (this.nodeList.conditionNodes.length > 1) {
          if (
            this.nodeList.conditionNodes[
              this.nodeList.conditionNodes.length - 1
            ].conditions.length == 0
          ) {
            this.nodeList.conditionNodes[
              this.nodeList.conditionNodes.length - 1
            ].content = "其他条件进入此流程";
            this.nodeList.conditionNodes[
              this.nodeList.conditionNodes.length - 1
            ].error = false;
          }
        }
      }

      this.$emit("update:nodeList", this.nodeList);
    },
    // 复制条件
    copyNode(val, index) {
      let nodesId = this._uid + Math.ceil(Math.random() * 100);
      let nodesId1 = this._uid + Math.ceil(Math.random() * 100);
      let temp = JSON.parse(JSON.stringify(this.nodeList.conditionNodes));
      for (let i = 0; i < temp.length; i++) {
        if (i == index) {
          val.name = val.name + "(复制)";
          val.nodeId = nodesId+'';
          
            console.info(nodesId1);
          if (val.childNode != null) {
            val.childNode.nodeId = nodesId1+'';
          }
          temp.splice(i + 1, 0, val);
        }
        console.info(temp);
      }
      this.nodeList.conditionNodes = temp;
      console.info(this.nodeList);
      var a = this.nodeList.conditionNodes.splice(val.priorityLevel - 1, 1); //截取旧下标
      this.nodeList.conditionNodes.splice(val.priorityLevel - 1, 0, a[0]); //填充新下标
      this.nodeList.conditionNodes.map((item, index) => {
        item.priorityLevel = index + 1;
      });
    },
    // 删除条件
    delCondition(index) {
      this.nodeList.conditionNodes.splice(index, 1);
      this.nodeList.conditionNodes.map((item, index) => {
        item.priorityLevel = index + 1;
        item.nodeName = `条件${index + 1}`;
      });
      // for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
      //     this.nodeConfig.conditionNodes[i].error = this.$func.conditionStr(this.nodeConfig, i) == "请设置条件" && i != this.nodeConfig.conditionNodes.length - 1
      // }
      this.$emit("update:nodeList", this.nodeList);
      if (this.nodeList.conditionNodes.length == 1) {
        if (this.nodeList.childNode) {
          if (this.nodeList.conditionNodes[0].childNode) {
            this.reData(
              this.nodeList.conditionNodes[0].childNode,
              this.nodeList.childNode
            );
          } else {
            this.nodeList.conditionNodes[0].childNode = this.nodeList.childNode;
          }
        }
        this.$emit(
          "update:nodeList",
          this.nodeList.conditionNodes[0].childNode
        );
      }
    },
    // 删除指定条件并替换
    reData(data, addData) {
      if (!data.childNode) {
        data.childNode = addData;
      } else {
        this.reData(data.childNode, addData);
      }
    },
    // 删除审核人以及其他..
    deleteNode() {
      this.$emit("update:nodeList", this.nodeList.childNode);
    },
    mergeCondition(val) {
      console.info(this.nodeList);
      this.setMergeData({ value: this.nodeList, flag: false, id: this._uid });
      this.setMerge(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.initiator-text {
  overflow: hidden;
  white-space: nowrap;
  width: 174px;
  text-overflow: ellipsis;
}
</style>